export default "__VITE_ASSET__DqVltpYc__"